import '@/assets/style/globalModal.css';
import { Modal } from 'antd';
import { AntButton } from '@/common/ant-components/AntButton';

export default function ConfirmModal({
  isVisible,
  onClose,
  onConfirm,
  loading,
  title,
  content,
}) {
  let ModalIcon = null;

  // Determine modal content based on the type

  return (
    <Modal
      className="custom-modal"
      title={<span className="modal-title">{title}</span>}
      open={isVisible}
      onCancel={onClose}
      onOk={onConfirm}
      closeIcon={false}
      width={400}
      centered={true}
      footer={[
        <AntButton key="submit" onClick={onConfirm} loading={loading}>
          Confirm
        </AntButton>,
        <AntButton
          key="back"
          onClick={onClose}
          style={{ marginRight: 8 }}
          color="red"
        >
          Cancel
        </AntButton>,
      ]}
    >
      <div className="modal-content">
        {ModalIcon && (
          <div className="gif-container">
            <img src={ModalIcon} alt="Modal GIF" className="modal-gif" />
          </div>
        )}

        <p className="modal-text">{content}</p>
      </div>
    </Modal>
  );
}
